import { useMemo } from "react";
import { useGetSlidesFoldersQuery } from "@/shared/services";
import type { TSlidesFolder } from "@/shared/types";

type TFolderWithChildren = TSlidesFolder & {
  children: TFolderWithChildren[];
};

export const useGetFolders = () => {
  const { data, isLoading } = useGetSlidesFoldersQuery();

  const folders = useMemo(() => {
    if (!data) return {};

    const buildNestedStructure = (
      allFolders: TSlidesFolder[],
      parentId: string,
    ): TFolderWithChildren[] => {
      return allFolders
        .filter((folder: TSlidesFolder) => folder.parentId === parentId)
        .map((folder: TSlidesFolder) => ({
          ...folder,
          children: buildNestedStructure(allFolders, folder._id),
        }));
    };

    return {
      userFolders: buildNestedStructure(data, "user-slides"),
      teamFolders: buildNestedStructure(data, "team-slides"),
    };
  }, [data]);

  return { folders, isLoading };
};
